import React, { useState } from 'react';
import { Box, Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TradingPartner from '../../components/Repository/TradingPartner/TradingPartner';
import AccountData from '../../components/Repository/AccountData/AccountData';
import PDCConnection from '../../components/Repository/PDCConnection';
import TrackingReports from '../../components/Repository/TrackingReports/TrackingReports';
import './RepositoryPage.css';

/**
 * RepositoryPage - Wrapper component for Repository management screens
 * Displays Trading Partner, Account Data, or PDC Administration based on pageType
 */
function RepositoryPage({ urlParams, pageType }) {
  const { t } = useTranslation();
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    message: '',
    severity: 'success'
  });

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, isOpen: false }));
  };

  // Mock handleClose since this is a standalone page, not a dialog
  const handleClose = () => {
    // In standalone mode, we could navigate back or show a message
    console.log('Close requested on repository page');
  };

  const getPageTitle = () => {
    switch (pageType) {
      case 'trading_partner':
        return t('DIAG_TRADING_PARTNER_TIT');
      case 'account_data':
        return t('ACCOUNT_DATA_RIGHTS');
      case 'pdc_admin':
        return t('BTN_PREDEF_CONN');
      case 'tracking_reports':
        return t('MNU_TRACKING_REPORTS');
      default:
    }
  };

  const renderContent = () => {
    switch (pageType) {
      case 'trading_partner':
        return (
          <TradingPartner 
            handleClose={handleClose}
            setOption={() => {}}
            source="repository_management"
          />
        );
      case 'account_data':
        return (
          <AccountData
            isTabVisible={true}
            handleClose={handleClose}
            tabOpen={true}
            setSnackbar={setSnackbar}
            setOption={() => {}}
            source="repository_management"
          />
        );
      case 'pdc_admin':
        return (
          <PDCConnection
            handleClose={handleClose}
            dir="IN"
            pdcName=""
            screen="PDC_ADMIN"
            origin="portal"
            onPdcSelect={(data) => console.log('PDC Selected:', data)}
            source="repository_management"
          />
        );
      case 'tracking_reports':
        return (
          <TrackingReports
            handleClose={handleClose}
            open={true}
            setSnackbar={setSnackbar}
          />
        );
      default:
        return (
          <Box className="flex align-center justify-center" sx={{ height: '100%', fontSize: '18px' }}>
            {t('CONTENT_UNDER_CONSTRUCTION')}
          </Box>
        );
    }
  };

  return (
    <div className="repository-page-container">
      <Box className="repository-page-header">
        <Box sx={{ fontSize: '20px', fontWeight: '600', padding: '1rem 1.5rem' }}>
          {getPageTitle()}
        </Box>
      </Box>
      
      <Box className="repository-page-content">
        {renderContent()}
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.isOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%', maxWidth: '450px' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default RepositoryPage;

